const getters = {
  shifts: (state) => state.shifts,
  getShift: (state) => (idx) => {
    return state.shifts[idx];
  },
  processing: (state) => state.processing,
};

export default getters;
